<template>
  <div>
    <movable class="testmove" pos-bottom="0" pos-right="0">
      <Me v-if="this.$store.getters['mediasoup/videoReady']" />
    </movable>
    <div class="button-bar">
      <BasicButtons
        :is-translator="false"
        :supports-screen-share="true"
        :local-mute="micPaused"
        :local-video-mute="vidPaused"
        :hand-raised="handRaised"
        :sharing="sharing"
        :req-to-speak-ongoing="reqToSpeakOngoing"
        @leave="$emit('leave')"
        @toggle-mute="$emit('toggle-mute')"
        @toggle-video-mute="$emit('toggle-video-mute')"
        @toggle-screen="$emit('toggle-screen')"
        @toggle-raiseHand="$emit('toggle-raiseHand')"
        @networkthrottle="$emit('networkthrottle')"
        @resetnetworkthrottle="$emit('resetnetworkthrottle')"
      />
    </div>
  </div>
</template>
<script>
/**
 * Controls for Participants and the own movable video tile
 * @displayName Host Overlay
 */
/* eslint-disable no-unused-vars*/
/* eslint-disable vue/no-unused-components*/
import Me from "./Me.vue";
import BasicButtons from "./BasicButtons.vue";
import { mapState } from "vuex";

//Host Overlay for my Video Feed and Control options

export default {
  name: "HostOverlay",
  components: {
    Me,
    BasicButtons,
  },
  props: {
    event: Object,
    /**
     * Indicates whether a request to speak was send to moderator
     */
    reqToSpeakOngoing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      micPaused: (state) => state.mediasoup.micPaused,
      vidPaused: (state) => state.mediasoup.vidPaused,
      handRaised: (state) => state.mediasoup.handRaised,
      sharing: (state) => state.mediasoup.sharing,
    }),
  },
};
</script>

<style scoped></style>
